module.exports = __webpack_public_path__ + "static/media/rightArrow.9102649a.svg";